import { useFormik } from 'formik';
import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import { declineClaim, resetUpdateSuccess } from '../../../redux/slice/claim/claimSlice';

const DeclineClaim = ({claim_process_uuid, claim_id, awaiting_status}) => {

    const { declineSuccess } = useSelector((state) => state.claim );

    const closeRef = useRef();
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const onSubmit = (values) => {
        const payload = { ...values, claim_process_uuid, claim_id, awaiting_status}
        dispatch(declineClaim(payload))
        // closeRef.current.click()
      }
  
      const validationScehma = Yup.object().shape({
        decline_comment: Yup.string("").required(
          "Reason cannot be blank"
        ),
      });

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
        enableReinitialize: true,
        initialValues: {
        decline_comment: '',
        },
        validationSchema: validationScehma,
        onSubmit,
    });

    useEffect(() => {
      if (declineSuccess) {
        closeRef.current.click()
        dispatch(resetUpdateSuccess())
        navigate('/admin/claims/all-claims')
      }
    }, [declineSuccess, dispatch, navigate])
    
  return (
    <div className='container'>
        <div className='my-3 text-center'>
            <h3 className='text-dark fs-3'>Decline Claim</h3>
            <p className='lh-sm fs-6'>
                Are you sure you want to decline this claim
            </p>
        </div>
        <div>
            <div className="row mb-3">
                <div className='col-sm-12'>
                    <label for="decline_comment" className="col-form-label">
                    Reason for Declining
                    </label>
                </div>
                <div class="col-sm-12">
                    <textarea type="text" name='decline_comment' className="form-control form-control-sm" id="decline_comment" 
                    value={values?.decline_comment} onChange={handleChange} onBlur={handleBlur}
                    />
                    {errors?.decline_comment && touched?.decline_comment && (
                        <p className='mb-0 text-danger'>
                            {errors?.decline_comment + '*'}
                        </p>
                    )}
                </div>
            </div>
        </div>
        <div className='d-flex justify-content-between'>
            <div className='d-grid'>
                <button
                ref={closeRef}
                className='btn btn-sm mt-2 px-3 text-muted'
                data-bs-dismiss='modal'
                style={{ background: "#F1F0F1" }}
                >
                Cancel
                </button>
            </div>
            <div className='d-grid'>
                <button
                onClick={handleSubmit}
                className='btn btn-danger btn-sm mt-2 px-3 text-white'
                >
                Decline
                </button>
            </div>
        </div>
    </div>
  )
}

export default DeclineClaim